import React, { useEffect, useState } from "react";
import "./My_History.css";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomPagination from "../../../Common/Common_Component/CustomPagination/CustomPagination";
import { GetAllHistory } from "../../../../features/games/color_prediction/Slice";
import { useDispatch, useSelector } from "react-redux";
import { formatAmount, formatNotifDate } from "../../../../utils/common";

// const getVariant = (color) => {
//   if (!color) return "gray";
//   const c = color.toLowerCase();
//   if (c.includes("violet") && c.includes("green")) return "green_violet";
//   if (c.includes("violet") && c.includes("red")) return "red_violet";
//   if (c.includes("green")) return "green";
//   if (c.includes("red")) return "red";
//   if (c.includes("violet")) return "violet";
//   return "gray";
// };
const getVariant = (color) => {
  if (!color) return "gray";
  const c = color.toLowerCase();
  if (c.includes("5")) return "green_violet";
  if (c.includes("0")) return "red_violet";
  if (c.includes("1") || c.includes("3") || c.includes("7") || c.includes("9")) return "green"
  if (c.includes("2") || c.includes("4") || c.includes("6") || c.includes("8")) return "red"
  if (c.includes("green")) return "green";
  if (c.includes("small")) return "small";
  if (c.includes("big")) return "big";
  if (c.includes("red")) return "red";
  if (c.includes("violet")) return "violet";
  return "gray";
};
const getTypeAndLabel = (bettingOption, optionType) => {
  if (optionType === "color") return { type: "color", label: "" };
  if (optionType === "size") return { type: "text", label: bettingOption?.charAt(0)?.toUpperCase() }; // "Big"→"B"
  if (optionType === "number") return { type: "number", label: bettingOption };
  return { type: "color", label: "" };
};

const transformItem = (item) => {
  const result = item?.Period?.Number_Result;
  const bettingOpt = item?.Rate?.betting_options ?? "";
  const optionType = item?.Rate?.type ?? "color";
  const { type, label } = getTypeAndLabel(bettingOpt, optionType);

  const colors = result?.color
    ? result.color.split(",").map((c) => c.trim())
    : [];
  console.log({ bettingOpt });

  return {
    variant: getVariant(bettingOpt),
    type,
    label,

    period: item?.Period?.period,
    date: item?.createdAt,

    result: item?.result,
    amount: item?.profit,

    details: {
      period: item?.Period?.period,
      purchaseAmount: item?.amount,
      platform_fee: item?.platform_fee,
      quantity: item?.quantity ?? 1,
      amountAfterTax: item?.amount_after_tax ?? item?.bet_amount,
      tax: item?.tax ?? 0,
      result: {
        num: result?.number,
        colors,
        size: result?.size,
      },
      select: bettingOpt,
      winLose: Math.max(item?.profit, item?.loss),
      orderTime: item?.createdAt,
    },
  };
};

function My_History({ mainActiveTab }) {
  const dispatch = useDispatch();
  const [expandedIndex, setExpandedIndex] = useState(0);

  const gameHistory = useSelector((state) => state.games.color_prediction);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const fetch = async (page) => {
    await dispatch(GetAllHistory({
      page,
      option_id: mainActiveTab?.option_id,
    }));
  };

  useEffect(() => {
    fetch(1);
  }, [dispatch, mainActiveTab]);

  const handlePageChange = async (page) => {
    fetch(page)
  };

  return (
    <>
      <section className="My_History">
        <div className="my-history-container">
          <table className="main-history-table">
            <tbody>
              {gameHistory?.Game_data?.map((rawItem, index) => {
                const item = transformItem(rawItem);
                const isExpanded = expandedIndex === index;
                const isWin = item?.result?.toLowerCase() === "win";
                return (
                  <React.Fragment key={index}>
                    <tr
                      className="history-header-row"
                      onClick={() => toggleExpand(index)}
                    >
                      {/* Icon Box */}
                      <td className="col-icon">
                        <div className={`icon-box bg-${item.variant}`}>
                          {item.type !== "color" ? item.label : ""}
                        </div>
                      </td>

                      {/* Period + Date */}
                      <td className="col-info">
                        <div className="id-text">
                          {item.period}
                          <span className="arrow">
                            <FontAwesomeIcon icon={isExpanded ? faSortUp : faSortDown} />
                          </span>
                        </div>
                        <div className="date-text">{formatNotifDate(item.date)}</div>
                      </td>

                      {/* Status + Amount */}
                      <td className="col-status">
                        <div className={`status-wrapper ${item?.result ? item?.result?.toLowerCase() : "pending"}`}>
                          <div className="status-badge">{item?.result || "Pending"}</div>
                          <div className="amount-text">{formatAmount(item.details?.winLose)}</div>
                        </div>
                      </td>
                    </tr>

                    {/* Expanded Details */}
                    <tr className={`details-expanded-row ${isExpanded ? "is-open" : ""}`}>
                      <td colSpan="3">
                        <div className="accordion-wrapper">
                          <div className="accordion-content">
                            <div className="details-inner-wrapper">
                              <h3 className="details-heading">Details</h3>
                              <table className="details-data-table">
                                <tbody>
                                  <tr>
                                    <td>Period</td>
                                    <td>{item.details?.period}</td>
                                  </tr>
                                  <tr>
                                    <td>Purchase amount</td>
                                    <td>{formatAmount(item.details?.purchaseAmount)}</td>
                                  </tr>

                                  <tr>
                                    <td>Result</td>
                                    <td>
                                      <span>{item.details?.result?.num}</span>{" "}
                                      {item.details?.result?.colors?.map((clr, i) => (
                                        <span key={i} className={`clr-${clr?.toLowerCase()}`}>
                                          {clr}{" "}
                                        </span>
                                      ))}
                                      <span className="clr-blue">{item.details?.result?.size}</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Select</td>
                                    <td >{item.details?.select}</td>
                                  </tr>
                                  <tr>
                                    <td>Status</td>
                                    <td className={isWin ? "clr-green" : "clr-red"}>
                                      {item?.result || "Pending"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Platform Fee</td>
                                    <td >
                                      {formatAmount(item?.details?.platform_fee)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Win / Lose</td>
                                    <td className={isWin ? "clr-green" : "clr-red"}>
                                      {formatAmount(item.details?.winLose)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Order Time</td>
                                    <td>{formatNotifDate(item.details?.orderTime)}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
      {gameHistory?.Game_data?.length > 0 &&
        <CustomPagination currentPage={gameHistory?.history_pagination?.current_page}
          totalPages={gameHistory?.history_pagination?.total_pages}
          handlePageChange={handlePageChange} />
      }
    </>
  );
}

export default My_History;